<template>
  <a-drawer
    ref="drawer"
    class="custom-drawer"
    v-bind="$attrs"
    :width="width"

    :closable="false"
    :headerStyle="{
      border: 0,
      padding: spacings.xxl,
    }"
    :bodyStyle="{
      paddingLeft: spacings.xxl,
      paddingRight: spacings.xxl,
    }"
    @close="$emit('close', $event)"
  >
    <template #title>
      <div class="flex-row justify-content-between align-items-center">
        <div class="flex-row align-items-center gap-xs">
          <span
            data-dusk="drawer-close"
            :style="{ cursor: 'pointer' }"
            @click="$refs.drawer.close()"
          >
            <ChevronLeftIcon class="icon-size-xl fill-primary" />
          </span>
          <h2 class="drawer-header m-0">
            {{ title }}
          </h2>
        </div>
        <slot name="action"></slot>
      </div>
    </template>

    <slot></slot>
  </a-drawer>
</template>

<script>
import Spacings from "../enums/Spacings";

export default {
  name: "Drawer.vue",
  emits: ["close"],
  props: {
    title: String,
    width: {
      default: "60vw",
      required: false,
      type: [Number, String],
    },
  },
  computed: {
    spacings() {
      return Spacings;
    },
  },
  methods: {
    close() {
      this.$refs.drawer.close();
    },
  },
};
</script>

<style lang="scss">
@import "~@/_default.scss";

.custom-drawer {
  h2.drawer-header {
    font-size: 24px !important;
  }

  .ant-drawer-content {
    border-radius: $border-radius-base 0 0 $border-radius-base;
  }
}

.ant-drawer-content-wrapper {
  max-width: 100vw;
}
</style>
